
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  watch
} from "vue";
import { imagesUrl } from "../../../../../domain/entities/shop/product/product";

const __default__ = defineComponent({
  name: "HoverGallery",
  props: {
    gallery: {
      type: Array as PropType<imagesUrl[]>,
      required: true
    },
    colorBorder: {
      type: String,
      default: "#c4c4c4"
    }
  },
  setup(props) {
    const isHover = ref<boolean>(false);
    const gallery = computed(() => props.gallery);
    const renderImage = ref<string>("");
    const renderIndex = ref<number>(0);

    onMounted(() => {
      if (!gallery.value || !gallery.value[0])
        return (renderImage.value = require("../../../assets/static/icons/nothing-found.svg"));

      renderImage.value = gallery.value[0].url;
    });

    function nextImage() {
      renderIndex.value = renderIndex.value + 1;

      if (gallery?.value[renderIndex.value]?.url)
        return (renderImage.value = gallery.value[renderIndex.value].url);

      renderIndex.value = -1;
    }

    const intervalId = ref();
    watch(
      () => isHover.value,
      isHover => {
        if (isHover) return (intervalId.value = setInterval(nextImage, 950));

        clearInterval(intervalId.value);
      },
      { immediate: true }
    );

    watch(
      () => gallery.value,
      async () => {
        renderImage.value = gallery.value[0].url;
      }
    );

    return {
      renderImage,
      isHover
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "f4d4244a": (_ctx.colorBorder)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__